// Pure transformation helpers used by `avatar init` to derive project names,
// workspace names from git URLs, and build the ScaffoldVariables struct for
// template rendering. Extracted from init.ts for testability — no IO,
// no prompts, no git calls.

import type { ScaffoldVariables } from "../lib/project-tree-scaffolder.js";
import { readCliVersion } from "../lib/read-cli-version-from-package-json.js";

// Build the template-rendering variable bag. lastScan stamps "now" — tests
// that need a deterministic value should freeze time via vi.useFakeTimers().
// v3: bỏ `mode` (InitMode internal/client/library dead sau gộp 1 flow).
export function buildScaffoldVariables(args: {
  projectName: string;
  projectDescription: string;
  teamOwner: string;
  packVersion: string;
}): ScaffoldVariables {
  return {
    projectName: args.projectName,
    projectDescription: args.projectDescription,
    teamOwner: args.teamOwner,
    avatarVersion: readCliVersion(),
    packVersion: args.packVersion,
    lastScan: new Date().toISOString(),
  };
}
